$(function(){    
    $('.banner-slider__slick').slick({
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    });
});

$(window).on('resize', function(){
    if($(window).width() < 767 && !$('.transfer-information-slick').hasClass('slick-initialized')){
        setTransferInformationSlick();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    Livewire.hook('message.processed', () => {
        $('#destination').select2({
            selectionCssClass: 'style-select2--global',
        });

        setTransferInformationSlick();
    })
});

document.addEventListener('livewire:load', function() {
    const livewireComponent = document.getElementById('transfers-view');
    const idComponent = livewireComponent.getAttribute('wire:id');
    const transfersComponent = Livewire.find(idComponent);
    var previousPage = transfersComponent.pagination.current_page;

    let slider = document.getElementById('range-slider');

    let startMin = transfersComponent.startMin;
    let startMax = transfersComponent.startMax;
    let step = transfersComponent.step;

    // noUiSlider.create(slider, {
    //     start: [startMin, startMax],
    //     connect: true,
    //     step: step,
    //     range: {
    //         'min': startMin,
    //         'max': startMax,
    //     }
    // });

    // slider.noUiSlider.on('update', function(values, handle) {
    //     transfersComponent.set('priceMin', Number(values[0]));
    //     transfersComponent.set('priceMax', Number(values[1]));
    //     $('#slider-min-span').text(Number(values[0]));
    //     $('#slider-max-span').text(Number(values[1]));
    // });

    $('#destination').on('change', function() {
        transfersComponent.set('destination', this.value)
    });

    var transfer_date = flatpickr('#date', {
        dateFormat: 'd-m-Y',
        mode: 'range',
        disableMobile: 'true',
        minDate: new Date().fp_incr(1),
        locale: {
            rangeSeparator: ' - '
        }
    });

    transfersComponent.on('updateFlatpickr', function(transfer_type, date){
        let date_split = date.split(' - ');
        if(transfer_type == 'Redondo- Aeropuerto - Hotel - Aeropuerto'){
            transfer_date.set('mode', 'range');
            if (date_split.length == 2) {
                transfer_date.setDate(transfersComponent.date)
            } else {
                var final_date = moment(date_split[0], 'DD-MM-Y').add(7, 'days').format('DD-MM-Y');
                transfer_date.setDate(date_split[0]+' - '+final_date)
                transfersComponent.date = date_split[0]+' - '+final_date;
            }
        }
        if(transfer_type == 'Desde el Aeropuerto'){
            transfer_date.set('mode', 'single');
            transfer_date.setDate(date_split[0]);
            transfersComponent.date = date_split[0];
        }

        if(transfer_type == 'Hacia al Aeropuerto'){
            transfer_date.set('mode', 'single');
            transfer_date.setDate(date_split[0]);
            transfersComponent.date = date_split[0];
        }
    });

    transfersComponent.on('gtmViewList', function(transfers, lang) {
        tagManager.gtmViewItemList(transfers, lang, "transportacion");
    });

    transfersComponent.on('gtmSelectItem', function (service, lang) {
        tagManager.gtmSelectItem(service, lang);
    });

    transfersComponent.on('gtmAddToCart', function (service, lang) {
        tagManager.gtmAddToCart(service, lang);
    });

    Livewire.hook('message.processed', (message, component) => {
        const actualPage = transfersComponent.pagination.current_page;
        
        if (actualPage != previousPage) {
            const tours = transfersComponent.new_transfers;
            const lang = transfersComponent.language;
    
            tagManager.gtmViewItemList(tours, lang, "transportacion");
        }

        previousPage = actualPage;
    })
});

const setTransferInformationSlick = () => {
    $('.transfer-information-slick').slick({
        arrows: true,
        prevArrow: `<button type="button" class="button-slider button-slider--prev">
                        <span class="material-icons button-slider__icon">chevron_left</span>
                    </button>`,
        nextArrow: `<button type="button" class="button-slider button-slider--next">
                        <span class="material-icons button-slider__icon">chevron_right</span>
                    </button>`,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
};